/* 默认环境模式是开发模式 */
// 跳过下一行检查
// eslint-disable-next-line
const env = process.env.NODE_ENV
let mode = ''
if (env === 'development') {
  /* 本地环境 */
  mode = 'dev'
} else if (env === 'dev1') {
  /* 打包开发环境 */
  mode = 'dev'
} else if (env === 'testing') {
  /* 测试环境 */
  mode = 'test'
} else if (env === 'production') {
  /* 生产环境 */
  mode = 'prod'
} else if (env === 'preprod') {
  /* 灰度环境 */
  mode = 'preprod'
} else if (env === 'huawei') {
  /* 华为 */  
  mode = 'huawei'
}

/* 默认使用协议 */
const protocol = 'http'
// const baseConfig = {
//   protocols: {
//     http: '',
//     https: 'https://'
//   },
//   /* 开发环境 */
//   dev: {
//     base: 'http://172.16.6.77:5010/agw/',
//     rbacweb: 'http://172.16.6.83:18888/',
//     rbacapi: 'http://172.16.6.37:58080/',
//     appKey: 'http://172.16.6.37:58080/'
//   },
//   /* 测试环境 */
//   test: {
//     base: 'http://192.168.109.173:7010/agw/',
//     rbacweb: 'http://192.168.109.173:9000/',
//     rbacapi: 'http://192.168.109.173:7000/',
//     appKey: 'http://192.168.109.173:7000/'
//   },
//   /* 生产环境 */
//   prod: {
//     base: 'https://bossapi.miniclouds.cn/agw/',
//     rbacweb: 'https://boss.miniclouds.cn/',
//     rbacapi: 'https://userapi.miniclouds.cn/',
//     appKey: 'https://userapi.miniclouds.cn/'
//   },
//   /* 灰度 */
//   preprod: {
//     base: 'http://192.168.109.173:6010/agw/',
//     rbacweb: 'http://192.168.109.173:6777/',
//     rbacapi: 'http://192.168.109.173:6020/',
//     appKey: 'http://192.168.109.173:6020/'
//   },
//   /* 华为 */
//   huawei: {
//     base: 'http://bossapi.aimeowclouds.cn/agw/',
//     rbacweb: 'http://boss.aimeowclouds.cn/',
//     rbacapi: 'http://userapi.aimeowclouds.cn/',
//     appKey: 'http://miniapp.aimeowclouds.cn:55006/'
//   }
// }
/* 设置api转换 */
let apiFormat = (api = '', hostkey = 'base', pt = protocol) =>
  window.ENV.baseConfig.protocols[pt] + window.ENV.baseConfig[mode][hostkey] + api
let apiAccount = (api = '', hostkey = 'rbacapi', pt = protocol) =>
  window.ENV.baseConfig.protocols[pt] + window.ENV.baseConfig[mode][hostkey] + api
let apiApp = (api = '', hostkey = 'appKey', pt = protocol) =>
  window.ENV.baseConfig.protocols[pt] + window.ENV.baseConfig[mode][hostkey] + api
const api = {
  base: {
    login: window.ENV.baseConfig.protocols.http + window.ENV.baseConfig[mode].rbacweb + 'login.html',
    loginOut: window.ENV.baseConfig.protocols.http + window.ENV.baseConfig[mode].rbacapi + 'logout/ajaxLogout',
    loginChannel: window.ENV.baseConfig.protocols.http + window.ENV.baseConfig[mode].rbacweb + 'loginChannel.html',
    choose: window.ENV.baseConfig.protocols.http + window.ENV.baseConfig[mode].rbacweb + 'choose.html'
  },
  menu: {
    /* 查询所有菜单列表 */
    querySubSystemMenuList: apiAccount('sys/resource/querySubSystemMenuList')
  },
  /* 定义功能名称或者api分组名称 */
  apiList: {
    querySysList: apiAccount('sys/subsystem/queryLoginedUserAccessBizSysList'),
    oldquerySysList: apiAccount('sys/subsystem/querySysList'),
    queryLoginedUserAccessSimpleSysList: apiAccount('sys/subsystem/queryLoginedUserAccessSimpleSysList'),
    queryAvailableUserListV2: apiAccount('sys/user/queryAvailableUserListV2')
  },
  pay: {
    /* 查询所有渠道列表 */
    queryPayChannelList: apiFormat('payCtr/queryPayChannelList'),
    queryAllAppInfo: apiApp('sys/app/queryAllAppInfo'),
    /* 查询支付记录列表 */
    queryPayRecordListByPage: apiFormat('payCtr/queryPayRecordListByPage'),
    /* 根据支付订单id查询详情 */
    queryPayRecordById: apiFormat('payCtr/queryPayRecordById'),
    /* 查询所有虚拟商户列表 */
    queryVirtualSellerList: apiFormat('payCtr/queryVirtualSellerList'),
    /* 对账明细分页查询 */
    queryPaymentCheckDetailListByPage: apiFormat('paymentCtr/queryPaymentCheckDetailListByPage'),
    /* 对账批次分页查询 */
    queryPaymentBatchCheckListByPage: apiFormat('paymentCtr/queryPaymentBatchCheckListByPage'),
    /* 差错处理分页查询 */
    queryPaymentErrListByPage: apiFormat('paymentCtr/queryPaymentErrListByPage'),
    /* 处理差错订单 */
    updateHandleStatusByErrId: apiFormat('paymentCtr/updateHandleStatusByErrId'),
    /* 差错处理详情 */
    queryPaymentErrByErrId: apiFormat('paymentCtr/queryPaymentErrByErrId'),
    /* 退款列表查询 */
    queryRefundRecordListByPage: apiFormat('refundCtr/queryRefundRecordListByPage'),
    /* 退款详情 */
    queryRefundRecordById: apiFormat('refundCtr/queryRefundRecordById')
  },
  rechargeManagement: {
    /* 查询所有供应商 */
    querySupInfoAll: apiFormat('supInfoCtr/querySupInfoAll'),
    lockGetCode: apiFormat('verificationCodeLog/lockGetCode'),
    queryLockLogByPage: apiFormat('lockLog/queryLockLogByPage'),
    queryVerificationCodeRuleListByPage: apiFormat('verificationCodeRuleCtr/queryVerificationCodeRuleListByPage'),
    addVerificationCodeRule: apiFormat('verificationCodeRuleCtr/addVerificationCodeRule'),
    editVerificationCodeRule: apiFormat('verificationCodeRuleCtr/editVerificationCodeRule'),
    delVerificationCodeRule: apiFormat('verificationCodeRuleCtr/delVerificationCodeRule'),
    /* 查询供应商充值明细 */
    queryRecordListByPage: apiFormat('supAccountCtr/queryRecordListByPage'),
    /* 查询供应商充值明细详情 */
    queryRechargeRecordById: apiFormat('supAccountCtr/queryRechargeRecordById'),
    /* 查询供应商账户 */
    queryAccStatusBySupId: apiFormat('supAccountCtr/queryAccStatusBySupId'),
    /* 查询所有客户 */
    queryCustSimpleInfoList: apiFormat('custInfoCtr/queryCustSimpleInfoList'),
    /* 查询客户充值明细 */
    queryCusRecordListByPage: apiFormat('custAccountCtr/queryRecordListByPage'),
    /* 查询客户充值明细详情 */
    queryRecordById: apiFormat('custAccountCtr/queryRecordById'),
    queryRegistUserByPage: apiFormat('cucu/user/queryRegistUserByPage'),
    queryUserOperateLogByPage: apiFormat('cucu/user/queryUserOperateLogByPage'),
    queryVerificationLogByPage: apiFormat('verificationCodeLog/queryVerificationLogByPage'),
    modifyUserLockedByUserId: apiFormat('cucu/user/modifyUserLockedByUserId'),
    /* 查询客户账户 */
    queryCustAccountsByCustId: apiFormat(
      'custAccountCtr/queryCustAccountsByCustId'
    )
  },
  /* 上传 */
  fileUpload: apiFormat('fileCtr/fileUpload'),
  accountManagement: {
    /* 查询供应商账户记录 */
    querySupAccountListByPage: apiFormat(
      'supAccountCtr/querySupAccountListByPage'
    ),
    customerBalanceSnapshotTimingJob: apiFormat('custAccountCtr/customerBalanceSnapshotTimingJob'),
    queryCustomerBalanceSnapshotListByPage: apiFormat('custAccountCtr/queryCustomerBalanceSnapshotListByPage'),
    /* 更新供应商账户状态 */
    updateAccStatusById: apiFormat('supAccountCtr/updateAccStatusById'),
    /* 更新供应商账户 */
    updateSupAccount: apiFormat('supAccountCtr/updateSupAccount'),
    /* 新增供应商账户 */
    addSupAccount: apiFormat('supAccountCtr/addSupAccount'),
    /* 供应商账户充值 */
    supAccountRecharge: apiFormat('supAccountCtr/supAccountRecharge'),
    /* 客户账户分页查询 */
    queryCustAccountListByPage: apiFormat(
      'custAccountCtr/queryCustAccountListByPage'
    ),
    /* 更新客户账户状态 */
    updateCusAccStatusById: apiFormat('custAccountCtr/updateAccStatusById'),
    /* 更新客户账户 */
    updateCustAccount: apiFormat('custAccountCtr/updateCustAccount'),
    /* 新增客户账户 */
    addCustAccount: apiFormat('custAccountCtr/addCustAccount'),
    /* 客户账户充值 */
    custAccountRecharge: apiFormat('custAccountCtr/custAccountRecharge')
  },
  supplierSettlement: {
    /* 查询供应商结算单 */
    querySupBillSettlementRecord: apiFormat(
      'supBillSettlementCtr/querySupBillSettlementRecord'
    ),
    /* 查询供应商 */
    querySupInfoAllBySysId: apiFormat('supInfoCtr/querySupInfoAllBySysId'),
    /* 查询供应商核算单详细 */
    querySupBillBatchListById: apiFormat(
      'supCheckBillCtr/querySupBillBatchListById'
    ),
    /* 跟新供应商结算单 */
    confirmSupBillSettlement: apiFormat(
      'supBillSettlementCtr/confirmSupBillSettlement'
    ),
    /* 查询客户结算单 */
    querySettlementListByPage: apiFormat(
      'custBillSettlementCtr/querySettlementListByPage'
    ),
    /* 查询客户核算单明细 */
    queryBillDetailListById: apiFormat(
      'custBillCheckCtr/queryBillDetailListById'
    ),
    /* 幼儿园结算单保存 */
    confirmPaymentSett: apiFormat(
      'paymentCtr/confirmPaymentSett'
    ),
    /* 幼儿园结算单分页查询 */
    queryPaymentSettlementListByPage: apiFormat(
      'paymentCtr/queryPaymentSettlementListByPage'
    ),
    /* 跟新客户结算单 */
    confirmCustBillSettlement: apiFormat(
      'custBillSettlementCtr/confirmCustBillSettlement'
    )
  },
  billmanagement: {
    /* 供应商明细账单查询 */
    querySupDailyBillInfoListByPage: apiFormat(
      'supBillInfoCtr/querySupDailyBillInfoListByPage'
    ),
    /* 供应商明细账单下载 */
    downlodeSupBillInfo: apiFormat('supBillInfoCtr/downloadSupBill'),
    /* 生成供应商核算单 */
    addSupBillBatchAsSupRecord: apiFormat(
      'supCheckBillCtr/addSupBillBatchAsSupRecord'
    ),
    /* 客户明细账单查询 */
    queryCustBillDetailByPage: apiFormat(
      'custBillInfoCtr/queryCustBillDetailByPage'
    ),
    /* 客户明细账单下载 */
    downlodeCustBillInfo: apiFormat('custBillInfoCtr/downloadCustBill'),
    /* 生成客户核算单 */
    addCustBillCheckSheet: apiFormat('custBillCheckCtr/addCustBillCheckSheet'),
    /* 供应商调账历史查询 */
    querySupAdjustBillRecordByPage: apiFormat(
      'supAdjustBillRecordCtr/querySupAdjustBillRecordByPage'
    ),
    /* 供应商调账历史下载 */
    downloadSupAdjustBillRecord: apiFormat(
      'supAdjustBillRecordCtr/downloadSupAdjustBillRecord'
    ),
    /* 客户调账历史查询 */
    queryBillAdjustHistByPage: apiFormat(
      'custBillAdjustCtr/queryBillAdjustHistByPage'
    ),
    /* 客户调账历史下载 */
    downloadAdjustBillHist: apiFormat(
      'custBillAdjustCtr/downloadAdjustBillHist'
    ),
    /* 幼儿园调账历史分页查询 */
    queryPaymentAdjustHistListByPage: apiFormat(
      'paymentCtr/queryPaymentAdjustHistListByPage'
    ),
    /* 幼儿园调账历史导出 */
    downloadPayAdjustHist: apiFormat(
      'paymentCtr/downloadPayAdjustHist'
    ),
    /* 幼儿园明细账单查询 */
    queryPaymentBillCheckDetailByPage: apiFormat('paymentCtr/queryPaymentBillCheckDetailByPage'),
    /* 幼儿园账单生成核算单 */
    addPaymentBillCheck: apiFormat('paymentCtr/addPaymentBillCheck'),
    queryCustContractListByPage: apiFormat('custContractCtr/queryCustContractListByPage'),
    addCustContract: apiFormat('custContractCtr/addCustContract'),
    addCustContractRefProd: apiFormat('custContractCtr/addCustContractRefProd'),
    queryCustContractDetailInfoById: apiFormat('custContractCtr/queryCustContractDetailInfoById'),
    queryCustContractById: apiFormat('custContractCtr/queryCustContractById'),
    queryCustContractRefProdById: apiFormat('custContractCtr/queryCustContractRefProdById'),
    updateCustContract: apiFormat('custContractCtr/updateCustContract'),
    addCustContractDetailInfo: apiFormat('custContractCtr/addCustContractDetailInfo'),
    queryCustContractListByCustId: apiFormat('custContractCtr/queryCustContractListByCustId'),
    querySupContractListBySupId: apiFormat('supContractCtr/querySupContractListBySupId'),
    querySupContractListByPage: apiFormat('supContractCtr/querySupContractListByPage'),
    querySupContractById: apiFormat('supContractCtr/querySupContractById'),
    updateSupContract: apiFormat('supContractCtr/updateSupContract'),
    addSupContract: apiFormat('supContractCtr/addSupContract'),
    downloadPayRecord: apiFormat('payCtr/downloadPayRecord'),
    downloadRefundRecord: apiFormat('refundCtr/downloadRefundRecord')
  },
  accounting: {
    /* 供应商核算单分页查询 */
    querySupBillBatchAsSupListByPage: apiFormat('supCheckBillCtr/querySupBillBatchAsSupListByPage'),
    downloadSysCostIncome: apiFormat('statistic/downloadSysCostIncome'),
    downloadSysCallStatistic: apiFormat('operatAnalysisCtr/downloadSysCallStatistic'),
    /* 查询供应商核算单明细 */
    querySupBillBatchListById: apiFormat('supCheckBillCtr/querySupBillBatchListById'),
    /* 供应商自动核算 */
    autoCheckCharge: apiFormat('supCheckBillCtr/autoCheckCharge'),
    /* 供应商重新核算保存 */
    addAndDelSupBillBatchAsSupRecord: apiFormat('supCheckBillCtr/addAndDelSupBillBatchAsSupRecord'),
    /* 根据id查询核算单统计 */
    querySupBillBatchById: apiFormat('supCheckBillCtr/querySupBillBatchById'),
    /* 增加调账记录 */
    addSupAdjustBillRecordList: apiFormat('supAdjustBillRecordCtr/addSupAdjustBillRecordList'),
    /* 更新核算单统计 */
    updateSupBillRecord: apiFormat('supCheckBillCtr/updateSupBillRecord'),
    /* 下载供应商账单明细 */
    downloadSupBillInfoById: apiFormat('supCheckBillCtr/downloadSupBillInfoById'),
    /* 新增供应商结算单 */
    addSupBillSettlementRecord: apiFormat('supBillSettlementCtr/addSupBillSettlementRecord'),
    /* 客户核算单分页查询 */
    queryBillAsCustListByPage: apiFormat('custBillCheckCtr/queryBillAsCustListByPage'),
    /* 客户核算单明细查询 */
    queryBillDetailListById: apiFormat('custBillCheckCtr/queryBillDetailListById'),
    /* 下载客户账单明细 */
    downloadBillInfoById: apiFormat('custBillCheckCtr/downloadBillInfoById'),
    /* 根据id查询客户核算单统计 */
    queryCustBillInfoById: apiFormat('custBillCheckCtr/queryCustBillInfoById'),
    /* 客户自动核算 */
    autoCustCheckCharge: apiFormat('custBillCheckCtr/autoCheckCharge'),
    /* 客户重新核算保存 */
    addAndDelBillRecord: apiFormat('custBillCheckCtr/addAndDelBillRecord'),
    /* 客户更新核算单统计 */
    updateCustBillRecord: apiFormat('custBillCheckCtr/updateCustBillRecord'),
    /* 新增客户结算单 */
    addBillSettlementRecord: apiFormat('custBillSettlementCtr/addBillSettlementRecord'),
    /* 新增客户调账历史 */
    addBillAdjustHistList: apiFormat('custBillAdjustCtr/addBillAdjustHistList'),
    /* 幼儿园核算单分页查询 */
    queryPaymentBillCheckByPage: apiFormat(
      'paymentCtr/queryPaymentBillCheckByPage'
    ),
    /* 幼儿园核算单自动核算 */
    paymentBillCheckAutoCalculate: apiFormat(
      'paymentCtr/paymentBillCheckAutoCalculate'
    ),
    /* 幼儿园重新核算保存 */
    recalculatePaymentBillCheck: apiFormat(
      'paymentCtr/recalculatePaymentBillCheck'
    ),
    /* 幼儿园核算单自动核算明细查询 */
    queryPaymentBillCheckById: apiFormat(
      'paymentCtr/queryPaymentBillCheckById'
    ),
    /* 幼儿园核算单明细查询 */
    queryPaymentBillCheckInfoById: apiFormat(
      'paymentCtr/queryPaymentBillCheckInfoById'
    ),
    /* 幼儿园核算保存 */
    updatePaymentBillCheck: apiFormat(
      'paymentCtr/updatePaymentBillCheck'
    ),
    /* 幼儿园生成结算单 */
    generatePaymentBillSettlement: apiFormat(
      'paymentCtr/generatePaymentBillSettlement'
    ),
    /* 幼儿园明细账单下载 */
    downloadPaymentCheckDetail: apiFormat(
      'paymentCtr/downloadPaymentCheckDetail'
    )
  },
  customerManagement: {
    /* 分页模糊查询客户类型 */
    getCustTypeList: apiFormat('custType/getCustTypeList'),
    changeUserOrderStatus: apiFormat('orderUserCtr/changeUserOrderStatus'),
    queryUserOrderById: apiFormat('orderUserCtr/queryUserOrderById'),
    queryUserOrderListByPage: apiFormat('orderUserCtr/queryUserOrderListByPage'),
    /* 编辑保存客户类型 */
    editCustType: apiFormat('custType/editCustType'),
    /* 新增保存客户类型 */
    addCustType: apiFormat('custType/addCustType'),
    /* 删除客户类型 */
    delCustType: apiFormat('custType/delCustType'),
    /* 查询客户来源 */
    queryCustFromList: apiFormat('custInfoCtr/queryCustFromList'),
    /* 查询客户类型一级 */
    queryCustTypeFirst: apiFormat('custType/queryCustTypeFirst'),
    /* 查询客户类型子级 */
    queryCustTypeByParentCustTypeId: apiFormat('custType/queryCustTypeByParentCustTypeId'),
    /* 产品调价管理分页查询 */
    queryCustProdAdjustPriceByPage: apiFormat('custProdAdjustCtr/queryCustProdAdjustPriceByPage'),
    /* 产品调价详情查询 */
    queryCustProdAdjustPriceInfoByAdjustId: apiFormat('custProdAdjustCtr/queryCustProdAdjustPriceInfoByAdjustId'),
    /* 取消调价 */
    cancelCustProdAdjustPrice: apiFormat('custProdAdjustCtr/cancelCustProdAdjustPrice'),
    /* 客户信息列表查询 */
    queryCustInfoByPage: apiFormat('custInfoCtr/queryCustInfoByPage'),
    /* 客户信息批量删除 */
    deleteCustInfoByCustId: apiFormat('compCustInfoCtr/deleteCustInfo'),
    /* 客户信息切换状态 */
    updateCustStateById: apiFormat('custInfoCtr/updateCustStateById'),
    /* 产品分配列表 */
    getCustomerAbilitysGroupBySystem: apiFormat('custProduct/getCustomerAbilitysGroupBySystem'),
    /* 保存产品分配 */
    allotProductIdsByCustomerId: apiFormat('custProduct/allotProductIdsByCustomerId'),
    /* 客户信息管理中的商务经理列表 */
    getAbuList: apiFormat('abuInfoCtr/getAbuList'),
    /* 客户信息管理中的登录名列表 */
    queryAvailableUserList: apiAccount('sys/user/queryAvailableUserList'),
    /* 客户信息查询单条详情 */
    getCustInfoById: apiFormat('custInfoCtr/getCustInfoById'),
    /* 客户信息编辑保存 */
    updateCustInfo: apiFormat('custInfoCtr/updateCustInfo'),
    /* 客户信息新增保存 */
    addCustInfo: apiFormat('custInfoCtr/addCustInfo'),
    /* 客户产品管理产品名称 */
    queryFastAbilityInfoList: apiFormat('abilityInfoCtr/queryFastAbilityInfoList'),
    /* 客户产品管理列表 */
    queryCustomerProductBySearchCustProduct: apiFormat('custProduct/queryCustomerProductBySearchCustProduct'),
    /* 客户产品管理 变更记录列表 */
    queryCustomerProductRecordByCustProductId: apiFormat('custProduct/queryCustomerProductRecordByCustProductId'),
    /* 客户产品管理切换状态弹窗查询详情 */
    queryCustProdStatusByCustProdId: apiFormat('custProduct/queryCustProdStatusByCustProdId'),
    /* 客户产品管理切换状态弹窗更新保存 */
    updateCustomerProducStatust: apiFormat('custProduct/updateCustomerProducStatust'),
    /* 客户产品管理分配通道组弹窗查询描述和选中通道组id */
    queryCustProdDescGroupById: apiFormat('custProduct/queryCustProdDescGroupById'),
    /* 客户产品管理分配通道组弹窗查询当前通道组列表 */
    queryGroupListByProdId: apiFormat('prodCtr/queryGroupListByProdId'),
    /* 客户产品管理分配通道组弹窗查询选中通道组下的table列表 */
    queryPipeListByGroup: apiFormat('prodCtr/queryPipeListByGroup'),
    /* 客户产品管理分配通道组弹窗 保存 */
    specifyUserProdPipeGroup: apiFormat('abilityUserGroupRefCtr/specifyUserProdPipeGroup'),
    /* 客户产品管理 客户产品调价 */
    queryProdReturnTypeList: apiFormat('prodCtr/queryProdReturnTypeList'),
    /* 客户产品管理 客户产品调价 */
    queryCustProdAdjustPriceInfoByCustProdId: apiFormat('custProduct/queryCustProdAdjustPriceInfoByCustProdId'),
    /* 客户产品管理 客户产品调价保存 */
    adjustCustProdPrice: apiFormat('custProduct/adjustCustProdPrice'),
    /* 客户类型管理 客户类型树列表 */
    queryCustTypeTree: apiFormat('custType/queryCustTypeTree'),
    /* 客户类型管理 客户类型查询详情 */
    queryCustTypeById: apiFormat('custType/queryCustTypeById'),
    /* 客户类型管理 保存编辑详情 */
    editCustType2: apiFormat('custType/editCustType'),
    /* 客户类型管理 删除客户类型 */
    delCustType2: apiFormat('custType/delCustType'),
    /* 客户类型管理 新增客户类型 */
    addCustType2: apiFormat('custType/addCustType'),
    addHardProdInfo: apiFormat('hardProdCtr/addHardProdInfo'),
    editHardProdInfo: apiFormat('hardProdCtr/editHardProdInfo'),
    queryHardProdByPage: apiFormat('hardProdCtr/queryHardProdByPage'),
    queryHardProdByProdId: apiFormat('hardProdCtr/queryHardProdByProdId'),
    delHardProdInfo: apiFormat('hardProdCtr/delHardProdInfo'),
    addPersonCustInfo: apiFormat('perCustInfoCtr/addPersonCustInfo'),
    addDetailInfo: apiFormat('perCustInfoCtr/addDetailInfo'),
    addAccInfo: apiFormat('compCustInfoCtr/addAccInfo'),
    addAbuInfo: apiFormat('compCustInfoCtr/addAbuInfo'),
    addExtInfo: apiFormat('compCustInfoCtr/addExtInfo'),
    queryCustInfoById: apiFormat('perCustInfoCtr/queryCustInfoById'),
    queryDetailById: apiFormat('perCustInfoCtr/queryDetailById'),
    updatePersonCustInfo: apiFormat('perCustInfoCtr/updatePersonCustInfo'),
    queryAccInfoById: apiFormat('compCustInfoCtr/queryAccInfoById'),
    queryAbuInfoById: apiFormat('compCustInfoCtr/queryAbuInfoById'),
    queryExtInfoById: apiFormat('compCustInfoCtr/queryExtInfoById'),
    addCompanyCustInfo: apiFormat('compCustInfoCtr/addCompanyCustInfo'),
    addContactInfo: apiFormat('compCustInfoCtr/addContactInfo'),
    addCompCustInfoCtrDetailInfo: apiFormat('compCustInfoCtr/addDetailInfo'),
    queryContactInfoById: apiFormat('compCustInfoCtr/queryContactInfoById'),
    updateCompanyCustInfo: apiFormat('compCustInfoCtr/updateCompanyCustInfo'),
    queryCompanyCustInfoByPage: apiFormat('compCustInfoCtr/queryCompanyCustInfoByPage'),
    querycompCustInfoCtrInfoById: apiFormat('compCustInfoCtr/queryCustInfoById'),
    updateAccInfo: apiFormat('compCustInfoCtr/updateAccInfo'),
    querycompDeatilById: apiFormat('compCustInfoCtr/queryDetailById'),
    queryPersonCustInfoByPage: apiFormat('perCustInfoCtr/queryPersonCustInfoByPage'),
    exchageAbuInfo: apiFormat('compCustInfoCtr/exchageAbuInfo'),
    queryOrderCustListByPage: apiFormat('orderCustCtr/queryOrderCustListByPage'),
    addCustOrder: apiFormat('orderCustCtr/addCustOrder'),
    updateCustOrder: apiFormat('orderCustCtr/updateCustOrder'),
    queryCustOrderById: apiFormat('orderCustCtr/queryCustOrderById')
  },
  valuation: {
    /* 计价策略分页查询 */
    queryStrategyListByPage: apiFormat('chargeStrategyCtr/queryStrategyListByPage'),
    delChargeStrategyInfo: apiFormat('chargeStrategyCtr/delChargeStrategyInfo'),
    addChargeStrategyInfo: apiFormat('chargeStrategyCtr/addChargeStrategyInfo'),
    editChargeStrategyInfo: apiFormat('chargeStrategyCtr/editChargeStrategyInfo'),
    /* 计价规则分页查询 */
    queryChargeRuleListByPage: apiFormat('chargeRuleCtr/queryChargeRuleListByPage'),
    /* 计价规则切换状态 */
    updateChargeRuleStatus: apiFormat('chargeRuleCtr/updateChargeRuleStatus'),
    /* 删除计价规则 */
    deleteBatchChargeRule: apiFormat('chargeRuleCtr/deleteBatchChargeRule'),
    /* 计价规则查详情 */
    queryRuleById: apiFormat('chargeRuleCtr/queryRuleById'),
    /* 查询计价字段列表 */
    queryInterfaceParamInfoByAll: apiFormat('interfaceParamCtr/queryInterfaceParamInfoByAll'),
    /* 新增计价规则 */
    addChargeRule: apiFormat('chargeRuleCtr/addChargeRule'),
    /* 更新计价规则 */
    updateChargeRule: apiFormat('chargeRuleCtr/updateChargeRule')
  },
  product: {
    /* 产品类型分页查询 */
    getProdTypeList: apiFormat('prodTypeCtr/getProdTypeList'),
    /* 产品类型删除 */
    delProdType: apiFormat('prodTypeCtr/delProdType'),
    /* 产品类型新增 */
    addProdType: apiFormat('prodTypeCtr/addProdType'),
    /* 产品类型编辑 */
    editProdType: apiFormat('prodTypeCtr/editProdType'),
    /* 查看历史分页查询 */
    getAbilityModHistory: apiFormat('abilityInfoCtr/getAbilityModHistory'),
    /* 通道管理分页查询 */
    queryAbilityPipeByPage: apiFormat('abilityPipeCtr/queryAbilityPipeByPageV2'),
    /* 供应商详细查询 */
    querySupServiceBySupId: apiFormat('supServiceCtr/querySupServiceBySupId'),
    /* 编辑通道详情查询 */
    getAbilityPipeById: apiFormat('abilityPipeCtr/getAbilityPipeById'),
    /* 编辑通道保存 */
    updateAbilityPipe: apiFormat('abilityPipeCtr/updateAbilityPipeV2'),
    /* 新增通道保存 */
    addAbilityPipe: apiFormat('abilityPipeCtr/addAbilityPipeV2'),
    /* 已关联产品 */
    queryUsedAbilityGroup: apiFormat('abilityPipeCtr/queryUsedAbilityGroup'),
    /* 删除通道 */
    deleteAbilityPipe: apiFormat('abilityPipeCtr/deleteAbilityPipeV2'),
    /* 编辑通道组通道列表 */
    updatePipeListByGroup: apiFormat('prodCtr/updatePipeListByGroup'),
    /* 新增产品 */
    addProdInfo: apiFormat('prodCtr/addProdInfo'),
    /* 编辑产品 */
    updateProdInfo: apiFormat('prodCtr/updateProdInfo'),
    /* 查询产品的基本信息 */
    queryProdInfo: apiFormat('prodCtr/queryProdInfo'),
    /* 计价策略查询 */
    queryStrategyList: apiFormat('chargeStrategyCtr/queryStrategyList'),
    /* 计价规则查询 */
    queryRuleUnusedByStrategyId: apiFormat('chargeRuleCtr/queryRuleUnusedByStrategyId'),
    /* 计价字段查询 */
    queryInterfaceParamInfoByAll: apiFormat('interfaceParamCtr/queryInterfaceParamInfoByAll'),
    /* 产品关联规则查询 */
    queryChargeRule: apiFormat('prodCtr/queryChargeRule'),
    /* 所有通道查询 */
    queryPipesList: apiFormat('abilityPipeCtr/queryPipesList'),
    /* 通道过滤查询 */
    queryAvailablePipeListByProdGroupId: apiFormat('abilityPipeCtr/queryAvailablePipeListByProdGroupId'),
    /* 通道组关联通道查询 */
    queryPipeListByGroup: apiFormat('prodCtr/queryPipeListByGroup'),
    /* 产品关联计价规则 */
    specifyChargeRule: apiFormat('prodCtr/specifyChargeRule'),
    /* 新增通道组 */
    addGroup: apiFormat('prodCtr/addGroup'),
    /* 编辑通道组 */
    editGroup: apiFormat('prodCtr/editGroup'),
    /* 删除通道组 */
    delProdGroupInfo: apiFormat('prodCtr/delProdGroupInfo'),
    /* 已关联客户查询 */
    queryCustListByGroup: apiFormat('prodCtr/queryCustListByGroup'),
    /* 修改产品状态 */
    changeStatus: apiFormat('prodCtr/changeStatus'),
    /* 查询产品详情 */
    queryProdInfoDetail: apiFormat('prodCtr/queryProdInfoDetail'),
    /* 产品分页查询 */
    queryProdInfoByPage: apiFormat('prodCtr/queryProdInfoByPage'),
    /* 关联通道组查询 */
    queryGroupList: apiFormat('prodCtr/queryGroupList'),
    queryAlarmTypeById: apiFormat('alarmTypeCtr/queryAlarmTypeById'),
    deleteAlarmType: apiFormat('alarmTypeCtr/deleteAlarmType'),
    updateAlarmType: apiFormat('alarmTypeCtr/updateAlarmType'),
    addAlarmType: apiFormat('alarmTypeCtr/addAlarmType'),
    queryAlarmTypeByPage: apiFormat('alarmTypeCtr/queryAlarmTypeByPage'),
    queryAllAlarmTypeBySysIds: apiFormat('alarmTypeCtr/queryAllAlarmTypeBySysIds'),
    queryChargeRuleByProdId: apiFormat('prodCtr/queryChargeRuleByProdId'),
    assignChargeRuleByProdId: apiFormat('prodCtr/assignChargeRuleByProdId'),
    assignChargeFieldsByProdId: apiFormat('prodCtr/assignChargeFieldsByProdId'),
    queryChargeFieldsByProdId: apiFormat('prodCtr/queryChargeFieldsByProdId')
  },
  analysis: {
    /* 请求收入 花费 利润 */
    querySystemTotalCostIncome: apiFormat('statistic/querySystemTotalCostIncome'),
    /* 请求七天 的收入 花费 利润 */
    queryLatestSevenDaysCostIncome: apiFormat('statistic/queryLatestSevenDaysCostIncome'),
    /* 请求一月 的收入 花费 利润 */
    querySpecificMonthSysCostIncome: apiFormat('statistic/querySpecificMonthSysCostIncome'),
    /* 请求供应商 */
    querySupDataStatistic: apiFormat('operatAnalysisCtr/querySupDataStatistic'),
    /* 请求客户 */
    queryCustDataStatistic: apiFormat('operatAnalysisCtr/queryCustDataStatistic'),
    /* 请求调用量 */
    querySysCallStatistic: apiFormat('operatAnalysisCtr/querySysCallStatistic'),
    /* 请求登录 */
    queryLoginRank: apiFormat('operatAnalysisCtr/queryLoginRank'),
    /* 请求充值 */
    queryRechargeRank: apiFormat('operatAnalysisCtr/queryRechargeRank'),
    /* 请求支付分析饼图 */
    queryPayAmountByVirtualSeller: apiFormat('payAnalysisCtr/queryPayAmountByVirtualSeller'),
    queryPayCountByDateType: apiFormat('payAnalysisCtr/queryPayCountByDateType'),
    queryPayCountByVirtualSeller: apiFormat('payAnalysisCtr/queryPayCountByVirtualSeller'),
    queryPayConversionRate: apiFormat('payAnalysisCtr/queryPayConversionRate'),
    queryPayCountStatistic: apiFormat('payAnalysisCtr/queryPayCountStatistic'),
    queryBillStatistic: apiFormat('billAnalysisCtr/queryBillStatistic'),
    queryCustAnalysisData: apiFormat('statistic/queryCustAnalysisData'),
    queryCustCallNumByPage: apiFormat('statistic/queryCustCallNumByPage'),
    queryCustConsumeDataByPage: apiFormat('statistic/queryCustConsumeDataByPage'),
    queryCustChargeDataByPage: apiFormat('statistic/queryCustChargeDataByPage'),
    queryCustAdjustRank: apiFormat('billAnalysisCtr/queryCustAdjustRank')
  },
  home: {
    queryWorkProcessDetail: apiFormat('task/workflowCtr/queryWorkProcessDetail'),
    createWorkTask: apiFormat('task/workflowCtr/createWorkTask'),
    handleWorkTask: apiFormat('task/workflowCtr/handleWorkTask'),
    updateWorkTask: apiFormat('task/workflowCtr/updateWorkTask'),
    remindWorkTask: apiFormat('task/workflowCtr/remindWorkTask'),
    deleteWorkTask: apiFormat('task/workflowCtr/deleteWorkTask'),
    queryWorkTaskByPage: apiFormat('task/workflowCtr/queryWorkTaskByPage'),
    queryHandlerList: apiFormat('task/workflowCtr/queryHandlerList'),
    queryWorkTaskById: apiFormat('task/workflowCtr/queryWorkTaskById')
  },
  supplier: {
    /* 编辑保存供应商服务 */
    updateSupServiceInfo: apiFormat('supServiceCtr/updateSupServiceInfo'),
    /* 新增保存供应商服务 */
    addSupServiceInfo: apiFormat('supServiceCtr/addSupServiceInfo'),
    /* 查询供应商 */
    querySupInfoAllBySysId: apiFormat('supInfoCtr/querySupInfoAllBySysId'),
    /* 查询供应商账户信息 */
    queryAccountBySupId: apiFormat('supAccountCtr/queryAccountBySupId'),
    /* 查询供应商详细信息 */
    getSupServiceById: apiFormat('supServiceCtr/getSupServiceById'),
    /* 删除供应商服务 */
    deleteSupServiceInfo: apiFormat('supServiceCtr/deleteSupServiceInfo'),
    /* 供应商服务分页查询 */
    getSupServiceListByPage: apiFormat('supServiceCtr/getSupServiceListByPage'),
    /* 供应商档案分页查询 */
    getSupInfoListByPage: apiFormat('supInfoCtr/getSupInfoListByPage'),
    /* 更改供应商状态 */
    changeSupState: apiFormat('supInfoCtr/changeSupState'),
    /* 供应商删除 */
    deleteSupInfoById: apiFormat('supInfoCtr/deleteSupInfoById'),
    /* 供应商商务经理列表 */
    queryBusinessMangerList: apiAccount('sys/user/queryBusinessMangerList'),
    querySupAbuListAll: apiFormat('supAbuCtr/querySupAbuListAll'),
    /* 供应商新增保存 */
    addNewSupInfo: apiFormat('supInfoCtr/addNewSupInfo'),
    /* 供应商编辑保存 */
    updateSupInfoBySupId: apiFormat('supInfoCtr/updateSupInfoBySupId'),
    /* 供应商查询单个详情 */
    querySupInfoBySupId: apiFormat('supInfoCtr/querySupInfoBySupId'),
    /* 新增供应商基本信息 */
    addSupInfo: apiFormat('supInfoCtrV2/addSupInfo'),
    /* 新增编辑供应商联系人信息 */
    addSupContacts: apiFormat('supInfoCtrV2/addSupContacts'),
    /* 新增编辑供应商账户信息 */
    updateSupAllAccount: apiFormat('supAccountCtr/updateSupAllAccount'),
    /* 新增编辑供应商详细信息 */
    addSupDetailInfo: apiFormat('supInfoCtrV2/addSupDetailInfo'),
    /* 新增编辑供应商商务信息 */
    addSupAbuInfo: apiFormat('supInfoCtrV2/addSupAbuInfo'),
    /* 新增编辑供应商扩展信息 */
    addSupExtFieldList: apiFormat('supInfoCtrV2/addSupExtFieldList'),
    /* 查询供应商基本信息 */
    querySupInfo: apiFormat('supInfoCtrV2/querySupInfo'),
    /* 查询供应商联系人信息 */
    querySupContacts: apiFormat('supInfoCtrV2/querySupContacts'),
    querySupAllAccount: apiFormat('supAccountCtr/querySupAllAccount'),
    querySupDetailInfo: apiFormat('supInfoCtrV2/querySupDetailInfo'),
    querySupAbuInfo: apiFormat('supInfoCtrV2/querySupAbuInfo'),
    querySupExtFieldList: apiFormat('supInfoCtrV2/querySupExtFieldList'),
    updateSupInfo: apiFormat('supInfoCtrV2/updateSupInfo'),
    replaceSupAbuInfo: apiFormat('supInfoCtrV2/replaceSupAbuInfo'),
    queryGradeCode: apiFormat('dictionaryCtr/queryGradeCode'),
    queryIndustryCode: apiFormat('dictionaryCtr/queryIndustryCode'),
    queryAddrCode: apiFormat('dictionaryCtr/queryAddrCode'),
    queryCareerCode: apiFormat('dictionaryCtr/queryCareerCode')
  },
  brand: {
    addHardProdBrand: apiFormat('brandCtr/addHardProdBrand'),
    delHardProdBrand: apiFormat('brandCtr/delHardProdBrand'),
    addProdCategory: apiFormat('cateCtr/addProdCategory'),
    delProdCategory: apiFormat('cateCtr/delProdCategory'),
    addProdModel: apiFormat('modelCtr/addProdModel'),
    delProdModel: apiFormat('modelCtr/delProdModel'),
    queryBrandTreeBySource: apiFormat('brandCtr/queryBrandTreeBySource'),
    editHardProdBrand: apiFormat('brandCtr/editHardProdBrand'),
    editProdCategory: apiFormat('cateCtr/editProdCategory'),
    editProdModel: apiFormat('modelCtr/editProdModel'),
    queryProdBrandByBrandId: apiFormat('brandCtr/queryProdBrandByBrandId'),
    queryProdCategoryByCateId: apiFormat('cateCtr/queryProdCategoryByCateId'),
    queryProdModelByModelId: apiFormat('modelCtr/queryProdModelByModelId'),
    queryProdBrandBySource: apiFormat('brandCtr/queryProdBrandBySource'),
    queryProdCategoryByBrandId: apiFormat('cateCtr/queryProdCategoryByBrandId'),
    queryProdModelByCateId: apiFormat('modelCtr/queryProdModelByCateId')
  },
  tasksched: {
    /* 分页模糊查询定时任务列表 */
    queryTaskList: apiFormat('tasksched/queryTaskList'),
    /* 修改定时任务状态 */
    changeTaskStatus: apiFormat('tasksched/changeTaskStatus'),
    /* 创建定时任务 */
    create: apiFormat('tasksched/create'),
    /* 编辑定时任务 */
    edit: apiFormat('tasksched/edit'),
    /* 删除定时任务 */
    del: apiFormat('tasksched/del'),
    /* 根据taskId查询单个任务详情 */
    queryTaskDetail: apiFormat('tasksched/queryTaskDetail'),
    /* 分页模糊查询任务执行记录 */
    queryExecHistList: apiFormat('taskexec/queryExecHistList'),
    /* 立即重新执行失败的任务(不根据cron表达式) */
    rerunSchedTask: apiFormat('taskexec/rerunSchedTask')
  },
  warning: {
    /* 查询预警对象列表 */
    queryAlarmObjectListByPage: apiFormat(
      'alarmObjectCtr/queryAlarmObjectListByPage'
    ),
    /* 新增预警对象 */
    addAlarmObject: apiFormat('alarmObjectCtr/addAlarmObject'),
    /* 根据id查询预警对象详情 */
    queryAlarmObjectById: apiFormat('alarmObjectCtr/queryAlarmObjectById'),
    /* 更新预警对象 */
    updateAlarmObject: apiFormat('alarmObjectCtr/updateAlarmObject'),
    /* 删除预警对象 */
    deleteAlarmObject: apiFormat('alarmObjectCtr/deleteAlarmObject'),
    /* 查询预警规则列表 */
    queryAlarmRuleListByPage: apiFormat(
      'alarmRuleCtr/queryAlarmRuleListByPage'
    ),
    /* 新增预警规则 */
    addAlarmRule: apiFormat('alarmRuleCtr/addAlarmRule'),
    /* 根据id查询预警规则详情 */
    queryAlarmRuleById: apiFormat('alarmRuleCtr/queryAlarmRuleById'),
    /* 更新预警规则 */
    updateAlarmRule: apiFormat('alarmRuleCtr/updateAlarmRule'),
    /* 删除预警规则 */
    deleteAlarmRule: apiFormat('alarmRuleCtr/deleteAlarmRule'),
    /* 预警发送短信接口 */
    sendMessage: apiFormat('warnRuleCtr/sendMessage'),
    /* 查询预警记录列表 */
    queryAlarmRecodeListByPage: apiFormat(
      'alarmRecordCtr/queryAlarmRecodeListByPage'
    ),
    /* 查询所有预警类型 */
    queryAllAlarmType: apiFormat('alarmTypeCtr/queryAllAlarmType'),
    /* 查询所有预警对象 */
    queryAllAlarmObject: apiFormat('alarmObjectCtr/queryAlarmObjectListById'),
    /* 查询所有模板 */
    queryAllSmsTemplate: apiFormat('smsTemplateCtr/queryAllSmsTemplate')
  },
  config: {
    /* ! 分页查询全部数据 */
    queryInterfaceParamInfoListByPage: apiFormat(
      'interfaceParamCtr/queryInterfaceParamInfoListByPage'
    ),
    queryProdChargeFieldListByPage: apiFormat('prodChargeFieldCtr/queryProdChargeFieldListByPage'),
    addProdChargeField: apiFormat('prodChargeFieldCtr/addProdChargeField'),
    delProdChargeFieldById: apiFormat('prodChargeFieldCtr/delProdChargeFieldById'),
    editProdChargeField: apiFormat('prodChargeFieldCtr/editProdChargeField'),
    queryMsgHistoryByPageResp: apiFormat('msg/queryMsgHistoryByPageResp'),
    queryChannelByPageResp: apiFormat('msg/queryChannelByPageResp'),
    queryChannelById: apiFormat('msg/queryChannelById'),
    updateChannel: apiFormat('msg/updateChannel'),
    addChannel: apiFormat('msg/addChannel'),
    /* ! 新增接口参数 */
    addInterfaceParamInfo: apiFormat(
      'interfaceParamCtr/addInterfaceParamInfo'
    ),
    /* ! 编辑接口参数 */
    updateInterfaceParamInfo: apiFormat(
      'interfaceParamCtr/updateInterfaceParamInfo'
    ),
    /* ! 根据id查询接口参数详情 */
    queryInterfaceParamInfoById: apiFormat(
      'interfaceParamCtr/queryInterfaceParamInfoById'
    ),
    /* ! 查询所有参数名称集合 */
    queryInterfaceParamInfoByAll: apiFormat(
      'interfaceParamCtr/queryInterfaceParamInfoByAll'
    )
  }
}

export default api



// WEBPACK FOOTER //
// ./src/config/apiConfig.js